import { WindowNames } from '@cashier/cashier-model';

const openedWindowMap: Record<string, WindowProxy> = {};

const isWindowOpened = (name: string): boolean => {
  return (
    !!openedWindowMap[name] &&
    !!openedWindowMap[name].frames &&
    !openedWindowMap[name].closed
  );
};

export const ProviderWindowService = {
  initialize(name: string, path?: string): void {
    const openedWindow = this.get(name);
    if (openedWindow) {
      openedWindow.focus();

      return;
    }

    const newWindow = window.open(path || 'about:blank', '_blank');

    if (newWindow) {
      openedWindowMap[name] = newWindow;
      try {
        newWindow.name = name;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.info('cross origin request');
      }
    }

    if (!newWindow) {
      console.error('The action is blocked by the browser');
    }
  },

  redirect(url: string, isNewWindow = true): void {
    if (!isNewWindow) {
      const a = document.createElement('a');
      a.href = url;
      a.click();

      return;
    }

    const openedWindow = this.get(WindowNames.Window);

    if (openedWindow) {
      openedWindow.location = url;

      return;
    }

    this.initialize(WindowNames.Window, url);
  },

  close(name?: string): void {
    if (!name) {
      window.close();
      return;
    }

    const openedWindow = this.get(name);

    if (openedWindow) {
      try {
        openedWindow.close();
        delete openedWindowMap[name];
      } catch (e) {
        // eslint-disable-next-line no-console
        console.info('probably cross origin frame try to close');
      }
    }
  },

  writeContent(name: string, content: string): void {
    const newWindow = this.get(name);

    if (newWindow) {
      newWindow.document.write(content);
      newWindow.document.close();
    }
  },

  get(name: string): WindowProxy | null {
    if (!isWindowOpened(name)) {
      return null;
    }

    return openedWindowMap[name];
  },
};
